import { Button } from "@/components/ui/button";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

export type SortState<C extends string> = { column: C; direction: "asc" | "desc" };

export function toggleSort<C extends string>(prev: SortState<C>, column: C): SortState<C> {
  return prev.column === column
    ? { column, direction: prev.direction === "asc" ? "desc" : "asc" }
    : { column, direction: "asc" };
}

export function SortableHead<C extends string>({
  column,
  label,
  sort,
  onSort,
}: {
  column: C;
  label: string;
  sort: SortState<C>;
  onSort: (column: C) => void;
}) {
  const isActive = sort.column === column;
  const Icon = !isActive ? ArrowUpDown : sort.direction === "asc" ? ArrowUp : ArrowDown;
  return (
    <TableHead aria-sort={isActive ? (sort.direction === "asc" ? "ascending" : "descending") : "none"}>
      <Button variant="ghost" size="sm" className="-ml-3 h-8" onClick={() => onSort(column)}>
        {label}
        <Icon className={cn("ml-1 h-4 w-4", !isActive && "text-muted-foreground")} />
      </Button>
    </TableHead>
  );
}
